import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ShipmentLoadStatusChainFacade } from './shipment-load-status-chain.facade';
import { LoadIdView } from '../../../../models';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ShipmentLoadItemFacade } from '../shipment-load-item.facade';

@Injectable({ providedIn: 'root' })
export class ShipmentLoadStatusChainGuard {
  constructor(
    private shipmentLoadStatusChainFacade: ShipmentLoadStatusChainFacade,
    private shipmentLoadItemFacade: ShipmentLoadItemFacade,
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return this.shipmentLoadItemFacade.shipmentLoadIdentifier$.pipe(
      switchMap((identifier: LoadIdView) => {
        return loadStoreState(this.shipmentLoadStatusChainFacade, identifier);
      }),
    );
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.shipmentLoadStatusChainFacade);
  }
}
